jQuery(document).ready(function ($) {
    let jobListings = '#job-listings';

    if ($(jobListings).length) {
        // Initialize datatable
        // $(jobListings).DataTable();

        // Initialize mix filters
        let mixer = mixitup(jobListings, {
            selectors: {
                target: '.job-item'
            },
            multifilter: {
                enable: true // enable the multifilter extension for the mixer
            },
            callbacks: {
                onMixEnd: function (state) {
                }
            }
        });
    }
});